// a component for showing progress bars on a multistep form
Vue.component('form-progress', {
  template: `
    <div class="form-progress">
      <slot></slot>
    </div>
  `,
});

Vue.component('step', {
  template: `
    <p class="form-progress__bar" :class="cssClass">{{ name }}</p>
  `,

  props: {
    // the text that shows to the user
    name: {
      type: String,
      default: '',
      required: true,
    },
    // A unique "key" to identify the step on the page...
    // (since this component could appear more than one time on a single page).
    step: {
      type: String,
      required: true,
    },
  },

  // need to mutate status prop
  data() {
    return {
      status: null,
    }
  },

  // use a computed property for the CSS class to simplify the template bindings
  computed: {
    cssClass: function () { // eslint-disable-line object-shorthand
      let className = '';
      switch (this.status) {
        case 'active':
          className = 'form-progress__bar--active';
          break;
        case 'completed':
          className = 'form-progress__bar--complete';
          break;
        default:
          className = 'form-progress__bar--inactive';
          break;
      }
      return className;
    },
  },

  created() {
    // copy passed in initialStatus to the mutable status data property
    this.status = this.initialStatus;

    /**
     * Handle the status change Event that any vue app can emit.
     * @param {object} action
     * @param {string} action.step Should match a passed in `step` prop
     * @param {string} action.status Either 'inactive', 'active', or 'completed'
     */
    Event.$on('progress', (action) => {
      if (action && action.step && action.status
        && this.step === action.step
        && this.status !== action.status) {
        this.status = action.status;
      }
    });
  },
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/components/form-progress.js